import React from 'react'
import { Link } from 'react-router-dom';
import '../layouts/SalesManagementNavbar.scss';
import customer from '../assets/images/customer.svg';
import projectMaster from '../assets/images/projectMaster.svg';
import companyMaster from '../assets/images/companyMaster.svg';
import distributorMaster from '../assets/images/distributorMaster.svg';
import productMaster from '../assets/images/productMaster.svg';
const SalesManagementNavbar = () => {
    return (
        <div className='container-fluid sales-management-nav-bar'>
            <div className='row ml-4 mr-4 mt-5'>
                <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                                    <div className='d-flex'>
                                        <div className='card card1 m-3'>
                                            <Link to="/enquiry-list">
                                                <div className='card-body'>
                                                    <img src={customer}></img>
                                                    <h5 className='mt-3'>Enquiry</h5>
                                                </div>
                                                <div className='card-footer'>
                                                    <h6>Total enquiries : <span>1240</span></h6>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className='card card2 m-3'>
                                            <Link to="/quotation">

                                                <div className='card-body'>
                                                    <img src={projectMaster}></img>
                                                    <h5 className='mt-3'>Quotations</h5>
                                                </div>
                                                <div className='card-footer'>
                                                    <h6>Total quotations : <span>1240</span></h6>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className='card card3 m-3'>
                                            <Link to="/order-list">
                                                <div className='card-body'>
                                                    <img src={companyMaster}></img>
                                                    <h5 className='mt-3'>Orders</h5>
                                                </div>
                                                <div className='card-footer'>
                                                    <h6>Total orders : <span>1240</span></h6>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SalesManagementNavbar